
<vb-loading-spinner *ngIf="status.isLoading" [block]="true" [size]="'medium'">
</vb-loading-spinner>

<section *ngIf="view === POLLS_VIEW.List" class="height-full">
	<div [ngClass]="styles.emptyPoll" [hidden]="polls.length">
		<span>{{ (webcast.currentUser.canManagePolls ? 'Event_NoPollsMessage_EventHost' : 'Event_NoPollsMessage') | translate }}</span>
		<button [hidden]="!webcast.currentUser.canManagePolls" vbBtnPrimary (click)="setCreateView()">
			{{ 'Event_AddPoll' | translate | vbTitleCase: context.titleCase }}
		</button>
	</div>
	<div *ngIf="status.loaded" [hidden]="!polls.length" [ngClass]="[
			styles.pollInfoWrapper,
			webcast.currentUser.canManagePolls ? 'edit' : ''
		]" class="height-full">
		<tabset justified="true" class="sidebar-tabset sidebar-tabset-scrollable">
			<tab [heading]="'Event_Poll_Tab_All' | translate : { '0': polls.length }" tabOrder="1" role="menuitem">
				@if (webcast.currentUser.canManagePolls) {
					<vb-manage-poll-card class="margin-top-15" *ngFor="let poll of polls.$polls; trackBy: pollTrackBy" [poll]="poll" (pollEdited)="setEditView(poll)" (pollDeleted)="deletePoll(poll)">
					</vb-manage-poll-card>
				} @else {
					<vb-attendee-poll-card class="margin-top-15" *ngFor="let poll of polls.$polls; trackBy: pollTrackBy" [poll]="poll">
					</vb-attendee-poll-card>
				}
			</tab>
			<tab [heading]="'Event_Poll_Tab_Open' | translate: { '0': openPolls.length }" tabOrder="2" role="menuitem">
				@if (webcast.currentUser.canManagePolls) {
					<vb-manage-poll-card class="margin-top-15" *ngFor="let poll of openPolls; trackBy: pollTrackBy" [poll]="poll" (pollEdited)="setEditView(poll)" (pollDeleted)="deletePoll(poll)">
					</vb-manage-poll-card>
				} @else {
					<vb-attendee-poll-card class="margin-top-15" *ngFor="let poll of openPolls; trackBy: pollTrackBy" [poll]="poll">
					</vb-attendee-poll-card>
				}
			</tab>
			<tab [heading]="(webcast.currentUser.canManagePolls ? 'Event_Poll_Tab_Closed' : 'Event_Poll_Tab_Result') | translate: { '0': webcast.currentUser.canManagePolls ? closedPolls.length : publishedPolls.length }" tabOrder="3" role="menuitem">
				@if (webcast.currentUser.canManagePolls) {
					<vb-manage-poll-card class="margin-top-15" *ngFor="let poll of closedPolls; trackBy: pollTrackBy" [poll]="poll" (pollEdited)="setEditView(poll)" (pollDeleted)="deletePoll(poll)">
					</vb-manage-poll-card>
				} @else {
					<vb-attendee-poll-card class="margin-top-15" *ngFor="let poll of publishedPolls; trackBy: pollTrackBy" [poll]="poll">
					</vb-attendee-poll-card>
				}
			</tab>
		</tabset>
		<div class="d-flex justify-content-end" [ngClass]="styles.pollFooter">
			<button *ngIf="webcast.currentUser.canManagePolls" vbBtnPrimary (click)="setCreateView()" class="margin-top-5">
				{{ 'Event_AddPoll' | translate }}
			</button>
		</div>
	</div>
</section>

<vb-webcast-edit-poll-view *ngIf="view === POLLS_VIEW.Edit" [poll]="pollToEdit" [context]="context" (saved)="savePollForm($event.poll)" (cancelled)="setListView()">
</vb-webcast-edit-poll-view>

